import React from 'react';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';
import { ZIndexes } from '../../../../shared/ZIndexes';

const OverlayDiv = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  background-color: rgba(255, 255, 255, 0.8);
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  z-index: ${ZIndexes.ConsumerExploreUnavailableOverlay};
  color: ${Colors.GRAY_DARK_10};
  font-weight: 200;
`;

export const UnavailableOverlay: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => (
  <OverlayDiv {...props}>{children}</OverlayDiv>
);
